import React, {useState, useEffect} from 'react';

import './Login.css';
import Hosts from '../../Hosts'

import {

	repo_logo_link,
	repo_img_link,
  set_language,
} from '../../Utils';


// or
//import { Tabs } from '@material-ui/core';
import LoginForm from "./LoginForm";

const Login = ({ setToken }) => {

  const [lang, set_lang] = useState('pt');

  const change_lang = (l) => {
      set_language(l)
      set_lang(l)
      window.location.reload()

      //console.log('language', localStorage.getItem('lang'))
      //console.log('localstorage', localStorage)
  }

useEffect(() => {

    if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
        change_lang('pt')
    }
    else {
        set_lang(localStorage.getItem('lang'))
    }

    //console.log('language', localStorage.getItem('lang'))
    //console.log('localstorage', localStorage)


}, [])



  return (
    <div>

      <div className="login-wrapper">
        
        <div className="div-left" style={{
          backgroundImage: `url(` + repo_img_link("img-login.jpg") + `)`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}>

        </div>
        
        <div className="div-right">

          <div className="language-selector d-none">
              <button  className={"language " + (lang === 'pt' ? 'assec-current-lang': '')} onClick={() => change_lang('pt')}>PT</button>
              <span className='assec-pr-5 assec-pl-5'>|</span>
              <button  className={"language " + (lang === 'en' ? 'assec-current-lang': '') } onClick={() => change_lang('en')}>EN</button> 
          </div> 

          <div className="form-header">
            {/*<a href={Hosts.WEB_SITE_URI} rel="noreferrer" target="_blank">*/}
              <img alt='' src={repo_logo_link("logo.svg")} />      
            {/*</a> */}     
          </div>

          <div className="div-form">
              
            <LoginForm setToken={setToken} loginType='login' />            
          </div>
          <div className="form-footer">
            {/*<a href="{''}" rel="noreferrer" target="_blank">*/}
              <img alt='' src={repo_logo_link("apoios.svg")} />      
            {/*</a>*/}      
          </div>
        </div>
      </div>

    </div>

  );

}

export default Login;

